import { AbstractControl, ValidationErrors } from '@angular/forms';

export const matchSsns = (cntrl1: string, cntrl2: string) => {
  return (control: AbstractControl): ValidationErrors | null => {
    const confirmSsn = control.value;
    const ssnControl = control.root?.get(cntrl1);
    const confirmControl = control.root?.get(cntrl2);
    if (confirmSsn && ssnControl && confirmControl) {
      const ssnCntrl = ssnControl.value;
      const cSsnCntrl = confirmControl.value;
        if (confirmSsn !== ssnCntrl || (cSsnCntrl !== '' && cSsnCntrl !== confirmSsn)) {
        return { 'ssnMissmatch': true };
      }
    }
    return null;
  };
};

const isPassword = (value: string) => /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*()?.,])[A-Za-z\d!@#$%^&*()?.,]{12,25}$/.test(value);
export const isValidPassword = (control: AbstractControl): ValidationErrors | null => {
  const fieldValue = control.value;
  if (fieldValue && isPassword(fieldValue) === false) {
    return { password: true };
  }
  return null;
};

const userName = (value: string) => /^((?=[a-zA-Z]{2,})(?=\d*)(?=[.@_-]*))[A-Za-z0-9.@_-]{5,25}$/.test(value);
export const isUserName = (control: AbstractControl): ValidationErrors | null => {
  const fieldValue = control.value;
  if (fieldValue && userName(fieldValue) === false) {
    return { userName: true };
  }
  return null;
};

export const matchPasswords = (control: AbstractControl): ValidationErrors | null => {
  const confirmPassword = control.value;
  const passwordControl = control.root?.get('password');
  const confirmPasswordControl = control.root?.get('confirmPassword');
  if (confirmPassword && passwordControl && confirmPasswordControl) {
    const password = passwordControl.value;
    const cPassword = confirmPasswordControl.value;
    if (confirmPassword !== password || (cPassword !== '' && cPassword !== confirmPassword)) {
      return { mismatch: true };
    }
  }
  return null;
};

export const matchEmail = (cntrl1: string, cntrl2: string) => {
  return (control: AbstractControl): ValidationErrors | null => {
    if (control.value) {
      const emailCntrl = control.root?.get(cntrl1);
      const cEmailCntrl = control.root?.get(cntrl2);
      if (!emailCntrl || !cEmailCntrl) {
        return null;
      }
      if (cEmailCntrl.value !== '' && cEmailCntrl.value !== emailCntrl.value) {
        return { 'emailMissMatch': true };
      } else if (cEmailCntrl.value === emailCntrl.value) {
        emailCntrl.setErrors(null);
        cEmailCntrl.setErrors(null);
      }
    }
    return null;
  };
};
export const matchAccountOrRoutingNumber = (cntrl1: string, cntrl2: string) => {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      return null;
    }

    const accCntrl = control.root?.get(cntrl1);
    const cAccCntrl = control.root?.get(cntrl2);
    if (!accCntrl || !cAccCntrl) {
      return null;
    }

    if (cntrl1 === 'accountNumber') {
      return resolveMatchingControlError(accCntrl, cAccCntrl, 'accountNumberMissMatch');
    }

    if (cntrl1 === 'routingNumber') {
      return resolveMatchingControlError(accCntrl, cAccCntrl, 'routingNumberMissMatch');
    }

    return null;
  };
};

const resolveMatchingControlError = (
  primaryControl: AbstractControl,
  confirmControl: AbstractControl,
  errorKey: 'accountNumberMissMatch' | 'routingNumberMissMatch'
): ValidationErrors | null => {
  if (confirmControl.value !== '' && confirmControl.value !== primaryControl.value) {
    return { [errorKey]: true };
  }

  if (confirmControl.value === primaryControl.value) {
    primaryControl.setErrors(null);
    confirmControl.setErrors(null);
  }

  return null;
};

export const futureDate = () => {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      return null;
    }

    const selectedDate = new Date(control.value);
    if (Number.isNaN(selectedDate.getTime())) {
      return null;
    }

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    selectedDate.setHours(0, 0, 0, 0);

    return selectedDate > today ? { futureDate: true } : null;
  };
};

